import { Card } from '@braze/web-sdk';
import React from 'react';
import ReactDOM from 'react-dom';
import {
    DEFAULT_NOTIFICATION_TEMPLATE_ID,
    NOTIFICATION_TEMPLATES,
} from '../constants/notificationTemplates';
import { timeAgo } from '../utils/timeAgo';
import './NotificationUIManager.css';

interface ExtendedCard extends Card {
    created?: Date;
}

export function applyCardTemplateStyles(card: Card, cardEl: Element): void {
    const templateValue = Number(card?.extras?.template);
    const templateIndex =
        !templateValue || ![1, 2, 3].includes(templateValue)
            ? DEFAULT_NOTIFICATION_TEMPLATE_ID
            : templateValue;

    const { color, icon: Icon } = NOTIFICATION_TEMPLATES[templateIndex];

    (cardEl as HTMLElement).style.setProperty('--card-accent-color', color);
    addCardTimestampLabel(card, cardEl);

    if (Icon && !cardEl.querySelector('.card-icon')) {
        const iconContainer = document.createElement('div');
        iconContainer.className = 'card-icon';

        ReactDOM.render(<Icon />, iconContainer);
        cardEl.prepend(iconContainer);
    }
}

function addCardTimestampLabel(card: ExtendedCard, cardEl: Element): void {
    const bodyEl = cardEl.querySelector<HTMLElement>('.ab-card-body');
    if (!bodyEl) return;

    // Skip if timestamp already exists
    if (bodyEl.querySelector('.xDaysBackDiv')) return;

    const date = card.updated ?? card.created;
    if (!date) return;

    const label = timeAgo(date);
    if (!label) return;

    const timestampEl = createTimestampElement(label);

    // Insert after title; fall back to appending to body
    const titleEl = bodyEl.querySelector<HTMLElement>('.ab-title');
    if (titleEl) {
        titleEl.after(timestampEl);
    } else {
        bodyEl.append(timestampEl);
    }
}

function createTimestampElement(label: string): HTMLDivElement {
    const el = document.createElement('div');
    el.className = 'xDaysBackDiv';
    el.textContent = label;
    return el;
}
